/**
 * The playhead's time, outside React state. The player reports 30 frames a second; putting that in the editor's
 * state re-rendered the whole editor 30× a second, which starved the player — its audio re-synced over and over
 * (the music stuttered) and the preview drifted from the timeline. Only what shows the time (the playhead line,
 * the clock) subscribes; actions read it when they run.
 */
import { useSyncExternalStore } from 'react';

export interface Clock { get: () => number; set: (t: number) => void; subscribe: (fn: () => void) => () => void }

export function createClock(): Clock {
  let t = 0;
  const subs = new Set<() => void>();
  return {
    get: () => t,
    set: (v) => { if (v === t) return; t = v; subs.forEach((f) => f()); },
    subscribe: (f) => { subs.add(f); return () => { subs.delete(f); }; },
  };
}

export const useClock = (c: Clock): number => useSyncExternalStore(c.subscribe, c.get, c.get);
